module.exports = __webpack_public_path__ + "static/media/ATLogo.cb80ceaa.png";